export default __webpack_public_path__ + "static/media/al-img.5f623d63.png";